import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MonthSelectorComponent } from './month-selector.component';

@NgModule({
    imports: [CommonModule, TranslatePipe, TranslateDirective, MatSelectModule, MatIconModule],
    declarations: [MonthSelectorComponent],
    exports: [MonthSelectorComponent]
})
export class MonthSelectorModule {}
